import type { AvatarProps } from 'src/components/ui/avatar';
import type { CHAT_CLASS, FAVOURITE_TYPE } from 'src/types/enum';

import type { SidebarIcon } from './icons';

export enum SidebarMode {
  DEFAULT = 'default',
  ADMIN = 'admin'
}

export type NavItemType = 'default' | 'iconOnly';

export interface NavBadge {
  label?: string;
  variant?: 'Beta' | 'dot' | 'count';
  tooltip?: string;
  colorScheme?: 'default' | 'success' | 'error';
}

export interface NavAvatar {
  text?: string;
  src?: string | SidebarIcon;
  size?: AvatarProps['size'];
  variant?: AvatarProps['variant'];
  colorScheme?: AvatarProps['colorScheme'];
}

export interface NavItemModel {
  id: string;
  name: string;
  icon?: SidebarIcon;
  avatar?: NavAvatar;
  to?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  badge?: NavBadge;
  active?: boolean;
  endIcon?: SidebarIcon;
  endIconColorClass?: string;
}

export interface SectionModel {
  id: string;
  heading: string;
  items: NavItemModel[];
}

export interface FavouriteModel extends NavItemModel {
  kind: FAVOURITE_TYPE;
  isFavourite: boolean;
  canStartChat?: boolean;
  hasFilePermission?: boolean;
}

export interface ChatHistoryItem {
  id: number;
  title: string;
  chatClass?: CHAT_CLASS;
  rid?: number;
}

export interface ChatHistoryGroup {
  id: string;
  heading: string;
  chats: ChatHistoryItem[];
}

export type SidebarRow =
  | {
      type: 'groupHeader';
      id: string;
      heading: string;
      collapsed: boolean;
      onToggle: () => void;
    }
  | { type: 'favourite'; id: string; item: FavouriteModel }
  | { type: 'chat'; id: string; chat: ChatHistoryItem };
